// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file encryption/encryption_model.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenEnum, GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { enumDesc, fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

/**
 * Describes the file encryption/encryption_model.proto.
 */
export const file_encryption_encryption_model: GenFile =
  /*@__PURE__*/
  fileDesc(
    'CiFlbmNyeXB0aW9uL2VuY3J5cHRpb25fbW9kZWwucHJvdG8SFGNvbS5nZW0uYmZmLmNvbnRyYWN0IiwKCkUyZWVDb21taXQSDQoFZXBvY2gYASABKAMSDwoHcGF5bG9hZBgCIAEoDCJPCgtFMmVlV2VsY29tZRIQCghkZXZpY2VJZBgBIAEoCRIOCgZjaGF0SWQYAiABKAMSDQoFZXBvY2gYAyABKAMSDwoHcGF5bG9hZBgEIAEoDCKsAQoSRTJlZUFkZFBhcnRpY2lwYW50EhUKDXBhcnRpY2lwYW50SWQYASABKAMSQgoId2VsY29tZXMYAiADKAsyMC5jb20uZ2VtLmJmZi5jb250cmFjdC5FMmVlQWRkUGFydGljaXBhbnQuV2VsY29tZRo7CgdXZWxjb21lEhAKCGRldmljZUlkGAEgASgJEg0KBWVwb2NoGAIgASgDEg8KB3BheWxvYWQYAyABKAwibgoUVXNlckRldmljZUtleVBhY2thZ2USDgoGdXNlcklkGAEgASgDEhAKCGRldmljZUlkGAIgASgJEjQKCmtleVBhY2thZ2UYAyABKAsyIC5jb20uZ2VtLmJmZi5jb250cmFjdC5LZXlQYWNrYWdlIoMBCgpLZXlQYWNrYWdlEj0KCWFsZ29yaXRobRgBIAEoDjIqLmNvbS5nZW0uYmZmLmNvbnRyYWN0LktleVBhY2thZ2UuQWxnb3JpdGhtEgwKBGRhdGEYAiABKAwiKAoJQWxnb3JpdGhtEg8KC0NVUlZFXzI1NTE5EAASCgoGRURfNDQ4EAEihQEKFkRldmljZUtleVBhY2thZ2VzQ291bnQSPQoJYWxnb3JpdGhtGAEgASgOMiouY29tLmdlbS5iZmYuY29udHJhY3QuS2V5UGFja2FnZS5BbGdvcml0aG0SFAoMbWlzc2luZ0NvdW50GAIgASgFEhYKDmF2YWlsYWJsZUNvdW50GAMgASgFQhgKFGNvbS5nZW0uYmZmLmNvbnRyYWN0UAFiBnByb3RvMw'
  );

/**
 * @generated from message com.gem.bff.contract.E2eeCommit
 */
export type E2eeCommit = Message<'com.gem.bff.contract.E2eeCommit'> & {
  /**
   * @generated from field: int64 epoch = 1;
   */
  epoch: bigint;

  /**
   * @generated from field: bytes payload = 2;
   */
  payload: Uint8Array;
};

/**
 * Describes the message com.gem.bff.contract.E2eeCommit.
 * Use `create(E2eeCommitSchema)` to create a new message.
 */
export const E2eeCommitSchema: GenMessage<E2eeCommit> =
  /*@__PURE__*/
  messageDesc(file_encryption_encryption_model, 0);

/**
 * @generated from message com.gem.bff.contract.E2eeWelcome
 */
export type E2eeWelcome = Message<'com.gem.bff.contract.E2eeWelcome'> & {
  /**
   * @generated from field: string deviceId = 1;
   */
  deviceId: string;

  /**
   * @generated from field: int64 chatId = 2;
   */
  chatId: bigint;

  /**
   * @generated from field: int64 epoch = 3;
   */
  epoch: bigint;

  /**
   * @generated from field: bytes payload = 4;
   */
  payload: Uint8Array;
};

/**
 * Describes the message com.gem.bff.contract.E2eeWelcome.
 * Use `create(E2eeWelcomeSchema)` to create a new message.
 */
export const E2eeWelcomeSchema: GenMessage<E2eeWelcome> =
  /*@__PURE__*/
  messageDesc(file_encryption_encryption_model, 1);

/**
 * @generated from message com.gem.bff.contract.E2eeAddParticipant
 */
export type E2eeAddParticipant = Message<'com.gem.bff.contract.E2eeAddParticipant'> & {
  /**
   * @generated from field: int64 participantId = 1;
   */
  participantId: bigint;

  /**
   * @generated from field: repeated com.gem.bff.contract.E2eeAddParticipant.Welcome welcomes = 2;
   */
  welcomes: E2eeAddParticipant_Welcome[];
};

/**
 * Describes the message com.gem.bff.contract.E2eeAddParticipant.
 * Use `create(E2eeAddParticipantSchema)` to create a new message.
 */
export const E2eeAddParticipantSchema: GenMessage<E2eeAddParticipant> =
  /*@__PURE__*/
  messageDesc(file_encryption_encryption_model, 2);

/**
 * @generated from message com.gem.bff.contract.E2eeAddParticipant.Welcome
 */
export type E2eeAddParticipant_Welcome =
  Message<'com.gem.bff.contract.E2eeAddParticipant.Welcome'> & {
    /**
     * @generated from field: string deviceId = 1;
     */
    deviceId: string;

    /**
     * @generated from field: int64 epoch = 2;
     */
    epoch: bigint;

    /**
     * @generated from field: bytes payload = 3;
     */
    payload: Uint8Array;
  };

/**
 * Describes the message com.gem.bff.contract.E2eeAddParticipant.Welcome.
 * Use `create(E2eeAddParticipant_WelcomeSchema)` to create a new message.
 */
export const E2eeAddParticipant_WelcomeSchema: GenMessage<E2eeAddParticipant_Welcome> =
  /*@__PURE__*/
  messageDesc(file_encryption_encryption_model, 2, 0);

/**
 * @generated from message com.gem.bff.contract.UserDeviceKeyPackage
 */
export type UserDeviceKeyPackage = Message<'com.gem.bff.contract.UserDeviceKeyPackage'> & {
  /**
   * @generated from field: int64 userId = 1;
   */
  userId: bigint;

  /**
   * @generated from field: string deviceId = 2;
   */
  deviceId: string;

  /**
   * @generated from field: com.gem.bff.contract.KeyPackage keyPackage = 3;
   */
  keyPackage?: KeyPackage;
};

/**
 * Describes the message com.gem.bff.contract.UserDeviceKeyPackage.
 * Use `create(UserDeviceKeyPackageSchema)` to create a new message.
 */
export const UserDeviceKeyPackageSchema: GenMessage<UserDeviceKeyPackage> =
  /*@__PURE__*/
  messageDesc(file_encryption_encryption_model, 3);

/**
 * @generated from message com.gem.bff.contract.KeyPackage
 */
export type KeyPackage = Message<'com.gem.bff.contract.KeyPackage'> & {
  /**
   * @generated from field: com.gem.bff.contract.KeyPackage.Algorithm algorithm = 1;
   */
  algorithm: KeyPackage_Algorithm;

  /**
   * @generated from field: bytes data = 2;
   */
  data: Uint8Array;
};

/**
 * Describes the message com.gem.bff.contract.KeyPackage.
 * Use `create(KeyPackageSchema)` to create a new message.
 */
export const KeyPackageSchema: GenMessage<KeyPackage> =
  /*@__PURE__*/
  messageDesc(file_encryption_encryption_model, 4);

/**
 * @generated from enum com.gem.bff.contract.KeyPackage.Algorithm
 */
export enum KeyPackage_Algorithm {
  /**
   * @generated from enum value: CURVE_25519 = 0;
   */
  CURVE_25519 = 0,

  /**
   * @generated from enum value: ED_448 = 1;
   */
  ED_448 = 1,
}

/**
 * Describes the enum com.gem.bff.contract.KeyPackage.Algorithm.
 */
export const KeyPackage_AlgorithmSchema: GenEnum<KeyPackage_Algorithm> =
  /*@__PURE__*/
  enumDesc(file_encryption_encryption_model, 4, 0);

/**
 * @generated from message com.gem.bff.contract.DeviceKeyPackagesCount
 */
export type DeviceKeyPackagesCount = Message<'com.gem.bff.contract.DeviceKeyPackagesCount'> & {
  /**
   * @generated from field: com.gem.bff.contract.KeyPackage.Algorithm algorithm = 1;
   */
  algorithm: KeyPackage_Algorithm;

  /**
   * @generated from field: int32 missingCount = 2;
   */
  missingCount: number;

  /**
   * @generated from field: int32 availableCount = 3;
   */
  availableCount: number;
};

/**
 * Describes the message com.gem.bff.contract.DeviceKeyPackagesCount.
 * Use `create(DeviceKeyPackagesCountSchema)` to create a new message.
 */
export const DeviceKeyPackagesCountSchema: GenMessage<DeviceKeyPackagesCount> =
  /*@__PURE__*/
  messageDesc(file_encryption_encryption_model, 5);
